"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideModal = exports.openModal = exports.handleRedirect = exports.hideLoader = exports.showLoader = exports.showMessage = exports.initDefaultMessageBox = void 0;
var defaultMessageBox_js_1 = require("../../utils/defaultMessageBox.js");
var main_dom_js_1 = __importDefault(require("./main-dom.js"));
exports.initDefaultMessageBox = function () {
    if (document.readyState !== "loading") {
        initMessageBoxes();
    }
    else {
        document.addEventListener("DOMContentLoaded", function (event) {
            initMessageBoxes();
        });
    }
    function initMessageBoxes() {
        defaultMessageBox_js_1.initCSS();
        defaultMessageBox_js_1.addSuccessBox();
        defaultMessageBox_js_1.addErrorBox();
    }
};
exports.showMessage = function (msg, isError) {
    if (!document.querySelector("[data-ms-message='success']")) {
        exports.initDefaultMessageBox();
    }
    var messageBox;
    if (isError) {
        messageBox = document.querySelector("[data-ms-message='error']");
    }
    else {
        messageBox = document.querySelector("[data-ms-message='success']");
    }
    //set text
    var messageTextBox = messageBox.querySelector("[data-ms-message-text]");
    if (messageTextBox) {
        messageTextBox.innerHTML = msg;
    }
    messageBox.style.display = "block";
    //add event listener to close button
    var closeBtn = messageBox.querySelector("[data-ms-message-close]");
    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener("click", function () {
        messageBox.style.display = "none";
    });
    setTimeout(function () {
        messageBox.style.display = "none";
    }, 7000);
};
exports.showLoader = function (element) {
    if (element) {
        element.style.display = "block";
        return;
    }
    var cssEl = document.createElement("style");
    var css = ".ms__loader { width: 100%; height: 100%; overflow: hidden; position: fixed; top: 0; left: 0; display: flex; justify-content: center; align-items: center; z-index: 10000000; } #msLoader path { fill: #007ace; }";
    cssEl.appendChild(document.createTextNode(css));
    document.head.appendChild(cssEl);
    var loaderHTML = '<?xml version="1.0"?><div class="ms__loader"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="msLoader" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background: new 0 0 50 50; z-index:1000000" xml:space="preserve"><path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg></div>';
    var div = document.createElement("div");
    div.setAttribute("data-ms-loader", "true");
    div.innerHTML = loaderHTML;
    if (document.readyState !== "loading") {
        document.body.appendChild(div);
    }
    else {
        document.addEventListener("DOMContentLoaded", function (event) {
            document.body.appendChild(div);
        });
    }
};
exports.hideLoader = function (element) {
    var _a;
    if (element) {
        element.style.display = "none";
        return;
    }
    (_a = document.querySelector("[data-ms-loader]")) === null || _a === void 0 ? void 0 : _a.remove();
};
exports.handleRedirect = function (redirect, redirectOverride) {
    if (redirectOverride)
        return (window.location.href = redirectOverride);
    if (redirect && window.location.pathname !== redirect)
        return (window.location.href = redirect);
};
var modal;
exports.openModal = function (type, params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var resolveModal, modalPromise;
        return __generator(this, function (_a) {
            modalPromise = new Promise(function (resolve) {
                resolveModal = resolve;
            });
            modal = new main_dom_js_1.default({
                target: document.body,
                props: {
                    display: type.toLowerCase(),
                    params: params,
                    onSuccess: resolveModal,
                },
            });
            return [2 /*return*/, modalPromise];
        });
    });
};
exports.hideModal = function () {
    try {
        modal === null || modal === void 0 ? void 0 : modal.$destroy();
    }
    catch (e) { }
    exports.hideLoader();
};
